export default "__VITE_ASSET__GRk39T2E__"